import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Content from '../../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../../components/Component';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_products, loading_retrieve_products, reset_retrieve_products, success_retrieve_products } from '../../../../reducers/auth_tenant/retrieve_products_Slice';
import { RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { RETRIEVE_TENANT_PRODUCTS_API } from '../../../../api/api_data';
import { useSelector } from 'react-redux';
import { addThreeDots, joinWithCommas, messageToast } from '../../../../utils/Utils';
import * as app_consts from "../../../../utils/app_consts";
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import ViewProductValueModal from '../../../../components/modal/ViewProductValueModal';

const MainProductsValuation = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState();
  const [current_page_data, setCurrentPageData] = useState([]);
  const [sm, updateSm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [valueFilter, setValueFilter] = useState("All");
  const [view_product_value_modal, setViewProductValueModal] = useState(false);
  const [selected_id, setSelectedID] = useState("");


  useEffect(() => {
    retrieve_products();
  }, []);

  const retrieve_products = () => {
    setError("");
    setLoading(true);
    // Retrieve Products
    dispatch(tenant_auth_actions_helper(loading_retrieve_products, success_retrieve_products, fail_retrieve_products, RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PRODUCTS_API}`));
  };

  // Listen
  const retrieve_products_listener = useSelector((state) => state.retrieve_products.retrieve_products);

  useEffect(() => {
    if (retrieve_products_listener.status !== app_consts.IDLE)
    {
      if (retrieve_products_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_products_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_products_listener.message);
          messageToast(retrieve_products_listener.message, app_consts.FAIL);
        } else if (retrieve_products_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_products_listener.data);
          setCurrentPageData(retrieve_products_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer);
        }
        dispatch(reset_retrieve_products());
      }
    }
  }, [retrieve_products_listener]);

  // Group products by category with filtering
  const groupProductsByCategory = (products) => {
    if (!products) return [];

    // Apply filters
    let filtered = [...products];

    if (categoryFilter !== "All")
    {
      filtered = filtered.filter(item =>
        categoryFilter === "Uncategorized"
          ? !item.category
          : item.category === categoryFilter
      );
    }

    if (statusFilter !== "All")
    {
      filtered = filtered.filter(item => item.status === statusFilter.toLowerCase());
    }

    // New filter for products with/without values
    if (valueFilter !== "All")
    {
      filtered = filtered.filter(item => {
        const hasValue = item?.product_value !== null && item?.product_value !== undefined;
        return valueFilter === "Has Value" ? hasValue : !hasValue;
      });
    }

    if (searchTerm)
    {
      filtered = filtered.filter(item => {
        const searchStr = [
          item?.category,
          item.name,
          item.product_type,
          item.sku_no,
          ...(item.packet_sizes || []),
          item.status?.replace(/_/g, ' ').toUpperCase(),
        ].join(" ").toLowerCase();

        return searchStr.includes(searchTerm.toLowerCase());
      });
    }

    const grouped = filtered.reduce((acc, product) => {
      const category = product.category || 'Uncategorized';
      if (!acc[category])
      {
        acc[category] = [];
      }
      acc[category].push(product);
      return acc;
    }, {});

    return Object.entries(grouped)
      .map(([category, items]) => ({
        category,
        items,
        count: items.length
      }))
      .sort((a, b) => a.category.localeCompare(b.category));
  };

  // Get all unique categories for filter dropdown
  const getUniqueCategories = (products) => {
    if (!products) return [];
    const categories = new Set(products.map(p => p.category || 'Uncategorized'));
    return ['All', ...Array.from(categories).sort()];
  };

  const groupedProducts = groupProductsByCategory(current_page_data);
  const uniqueCategories = getUniqueCategories(current_page_data);

  // Pagination for categories
  const indexOfLastCategory = currentPage * itemPerPage;
  const indexOfFirstCategory = indexOfLastCategory - itemPerPage;
  const currentCategories = groupedProducts.slice(indexOfFirstCategory, indexOfLastCategory);
  const totalCategories = groupedProducts.length;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const open_view_product_value_modal = (id) => {
    setViewProductValueModal(true);
    setSelectedID(id);
  };

  const close_view_product_value_modal = () => {
    setViewProductValueModal(false);
    setSelectedID("");

  };

  return (
    <>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Products Value</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && current_page_data?.length > 0 && `Total Products ${current_page_data?.length}`}</p>
              </BlockDes>
              {!loading && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_products();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            {
              !(loading || error) && (
                <>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#more"
                        className="btn btn-icon btn-trigger toggle-expand me-n1"
                        onClick={(ev) => {
                          ev.preventDefault();
                          updateSm(!sm);
                        }}
                      >
                        <Icon name="more-v"></Icon>
                      </a>
                      <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                        <ul className="nk-block-tools g-3">
                          <li>
                            <div className="form-control-wrap">
                              <div className="form-icon form-icon-right">
                                <Icon name="search"></Icon>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                id="default-04"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                placeholder="Search for Products"
                              />
                            </div>
                          </li>
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle color="light" outline className="bg-white dropdown-toggle">
                                {categoryFilter === "All" ? "All Categories" : categoryFilter}
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem onClick={() => setCategoryFilter("All")}>All Categories</DropdownItem>
                                {uniqueCategories.filter(c => c !== "All").map(category => (
                                  <DropdownItem
                                    key={category}
                                    onClick={() => {
                                      setCategoryFilter(category);
                                      setCurrentPage(1);
                                    }}
                                  >
                                    {category}
                                  </DropdownItem>
                                ))}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle color="light" outline className="bg-white dropdown-toggle">
                                {valueFilter === "All" ? "All Values" : valueFilter}
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem onClick={() => setValueFilter("All")}>All Values</DropdownItem>
                                <DropdownItem onClick={() => {
                                  setValueFilter("Has Value");
                                  setCurrentPage(1);
                                }}>
                                  Has Value
                                </DropdownItem>
                                <DropdownItem onClick={() => {
                                  setValueFilter("No Value");
                                  setCurrentPage(1);
                                }}>
                                  No Value
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </>
              )
            }
          </BlockBetween>
        </BlockHead>


        {loading ? (
          <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Products..." />
        ) : error ? (
          <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
        ) : (
          <>
            {
              page_data && page_data?.length > 0 ?
                <>
                  {currentCategories.length > 0 ? (
                    currentCategories.map((group) => (
                      <div key={group.category} className="mb-4">
                        <div className="d-flex flex-column mb-3">
                          <h5 className="title" style={{ fontWeight: '600', color: '#2c3e50' }}>
                            {group.category}
                          </h5>
                          <div>
                            <Badge color="primary" className="w-auto badge-dim">
                              {group.count} {group.count === 1 ? 'product' : 'products'}
                            </Badge>
                          </div>
                        </div>

                        <Block>
                          <div className="nk-tb-list is-separate is-medium mb-3">
                            <DataTableHead className="nk-tb-item">
                              <DataTableRow>
                                <span className="sub-text">Brand</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">Name</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">Type</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">SKU No</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">Stock</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">Unit Value</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">Status</span>
                              </DataTableRow>
                              <DataTableRow>
                                <span className="sub-text">Action</span>
                              </DataTableRow>
                            </DataTableHead>
                            {group?.items.map((item, idx) => (
                              <DataTableItem key={item?.id} className="tb-tnx-item">
                                <DataTableRow size="sm">
                                  <Link onClick={(e) => { e.preventDefault(); open_view_product_value_modal(item?.id); }}>
                                    <span className="tb-product">
                                      <span className="title">{item?.category || "--"}</span>
                                    </span>
                                  </Link>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="tb-product">
                                    <div className="me-3" style={{ width: '60px', height: '60px' }}>
                                      <img
                                        src={item?.product_img}
                                        alt={item?.name}
                                        className="img-thumbnail rounded"
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          objectFit: 'cover',
                                          backgroundColor: '#f8f9fa'
                                        }}
                                      />
                                    </div>
                                    <span className="tb-sub">{item?.name || "--"}</span>
                                  </span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="tb-sub">{item?.product_type || "--"}</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="tb-sub">{item?.sku_no || "--"}</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="tb-sub">{item?.total_stock || "0"}</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="tb-sub">{item?.product_value ? `${parseFloat(item?.product_value).toFixed(2)} ZMW` : "--"}</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="tb-odr-status">
                                    <Badge
                                      color={
                                        item?.status === app_consts.ACTIVE
                                          ? "success"
                                          : "danger"
                                      }
                                      className="badge-dot"
                                    >
                                      {item?.status?.toUpperCase() || "--"}
                                    </Badge>
                                  </span>
                                </DataTableRow>
                                <DataTableRow className="nk-tb-col-tools">
                                  <div className="tb-odr-btns d-none d-sm-inline">
                                    <Link onClick={(e) => { e.preventDefault(); open_view_product_value_modal(item?.id); }}>
                                      <Button color="primary" size="sm" className="btn btn-dim">
                                        View
                                      </Button>
                                    </Link>
                                  </div>
                                  <Button className="btn-pd-auto d-sm-none">
                                    <Icon name="chevron-right"></Icon>
                                  </Button>
                                </DataTableRow>
                              </DataTableItem>
                            ))}
                          </div>
                        </Block>
                      </div>
                    ))
                  ) : (
                    <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No products match your filters"} />
                  )}

                  {totalCategories > 0 && (
                    <div className="mt-4">
                      <PaginationComponent
                        itemPerPage={itemPerPage}
                        totalItems={totalCategories}
                        paginate={paginate}
                        currentPage={currentPage}
                      />
                    </div>
                  )}
                  <ViewProductValueModal isOpen={view_product_value_modal} closeModal={close_view_product_value_modal} tenant_info={tenant_info} user_info={user_info} data={selected_id} successFunction={retrieve_products} />
                </>
                :
                <>
                  <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Products Found"} />
                </>
            }
          </>
        )
        }
      </Content>
    </>
  );
};

export default MainProductsValuation;